import axios from "axios";

type AuthType = {
  basicAuth: string;
  code: number;
  email: string;
  customerId: string;
  token?: string;
};

const BASE_URL_STORE = process.env.REACT_APP_API_URL || "";

// Cria a instância do axios
const apiAPP = axios.create({
  baseURL: BASE_URL_STORE,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
});

// Adiciona o interceptor de request
apiAPP.interceptors.request.use(
  (config) => {
    try {
      const auth = localStorage.getItem("auth");
      if (auth) {
        const authObj: AuthType = JSON.parse(auth);
        if (authObj?.basicAuth?.length > 0) {
          config.headers.Authorization = `Basic ${authObj.basicAuth}`;
        }
      }
    } catch (error) {
      console.warn("Erro ao processar auth no interceptor:", error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Exporta a instância e a baseURL
const apiConnect = { apiAPP, BASE_URL_STORE };
export default apiConnect;
